<template>
    <DragPanel>
        <div class="detail-panel">
            <div class="item" v-for="(item,index) in infoData.baseInfo" :key="'baseInfo'+index">
                <span>{{item.key+':'}}</span>
                <span>{{item.unit&&item.unit==='㎡' ? $common.thousandBitSeparator(item.value)+item.unit : item.value+item.unit}}</span>
            </div>
            <div class="item" v-for="(item,index) in infoData.indicatorComparison" :key="'indicatorComparison'+index">
                <div class="name-progress">
                    <div class="name">{{item.key}}:</div>
                    <el-progress
                        v-if="item.built!=='-'&&item.plan!=='-'&&item.plan>0"
                        :stroke-width="10"
                        :show-text="false"
                        v-bind:style="{width: getProgressWidth(item)}"
                        :percentage="getProgressValue(item)>=1 ? 100 : getProgressValue(item)*100"
                        :color="getProgressColor(item)">
                    </el-progress>
                </div>
                <div class="rate">
                    <span :style="{color:getProgressColor(item)}">{{item.unit&&item.unit==='㎡' ? $common.thousandBitSeparator(item.built)+item.unit : item.built+item.unit}}</span>
                    <span> / {{item.unit&&item.unit==='㎡' ? $common.thousandBitSeparator(item.plan)+item.unit : item.plan+item.unit}}</span>
                </div>
            </div>
            <div class="item" v-for="(item,index) in infoData.remainingIndicators" :key="'remainingIndicators'+index">
                <span>{{item.key+":"}}</span><span>{{item.unit ? item.value+item.unit: item.value}}</span>
            </div>
            <div class="item">附件:</div>
            <div class="piclist">
                <template v-for="(item,index) in piclist">
                    <img class="piclist-item" v-if="item.type.indexOf('image/')>-1" :key="'pic'+index" :src="item.url" @click="handlePreviewClick(index, 'pic')"/>
                    <div class="piclist-item" v-else :key="'pic'+index" @click="handlePreviewClick(index, 'pic')">
                        <video :src="item.url"></video>
                        <img class="icon-play" src="../../assets/images/digital/icon-play.png">
                    </div>
                </template>
            </div>
            <div class="item" v-for="(item,index) in filelist" :key="'file'+index">
                <div class="file-name" @click="handlePreviewClick(index, 'file')"><span>{{item.name}}</span><img :src="require('../../assets/images/digital/downloadicon/'+item.icontype+'.png')"/></div>
                <img style="cursor: pointer;" src="../../assets/images/digital/icon-download.png" @click="handleDownloadFile(item)"/>
            </div>
        </div>
    </DragPanel>
</template>

<script>
import DragPanel from './DragPanel'
export default {
    name: "DetailInfo",
    components: { DragPanel },
    props: {
        itemData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            infoData: {baseInfo:[],remainingIndicators:[],indicatorComparison:[]},
            progressbarWidth: 100
        }
    },
    created() {
      this.getInfoAxios()
    },
    computed: {
        piclist() {
            if(this.infoData && this.infoData.attachment) {
                let pics = this.infoData.attachment.filter( item => item.type.indexOf("image/") > -1 || item.type.indexOf("video/") > -1 )
                return pics
            }
            return []
        },
        filelist() {
            if(this.infoData && this.infoData.attachment) {
                let files = this.infoData.attachment.filter( item => item.type.indexOf("application/") > -1 || item.type.indexOf("text/plain") > -1 )
                files = files.map( item => {
                    item.icontype = this.$common.getFileIcontype(item.type)
                    return item
                });
                return files
            }
            return []
        }
    },
    watch: {
        'itemData.lotNumber'() {
            this.getInfoAxios()
        }
    },
    methods: {
        handleClose() {
            this.$parent.clearSelectedTree()
        },
        //获取地块信息
        getInfoAxios() {
            let _this = this;
            _this.infoData = {}
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/lot/info_card`
            this.$common.getTokenRequest()
            .get(url + '?lotNumber='+_this.itemData.lotNumber)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.infoData = data.data;
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/lot/info_card')
            })
        },
        //计算进度条百分比
        getProgressValue(data) {
            return (data.built/data.plan);
        },
        //获取进度条颜色
        getProgressColor(data) {
            let percent = data.built/data.plan
            if(percent < 1) {
                return '#409eff';
            } else if(percent === 1) {
                return '#2EA86E';
            } else if(percent > 1) {
                return '#FFB11B';
            }
            return '#409eff';
        },
        //计算进度条长度
        getProgressWidth(data) {
            let percent = data.built/data.plan
            if(percent <= 1) {
                return this.progressbarWidth+'px';
            } else if(percent > 1 && percent <=1.3){
               return this.getProgressValue(data) * this.progressbarWidth + 'px';
            } else {
                return 1.3 * this.progressbarWidth + 'px';
            }
        },
        //下载文件
        handleDownloadFile(item) {
            this.$axios
            .get(item.url, {responseType: 'blob'})
            .then(res => {
              if (res.status === 200) {
                this.$common.downloadFileStream(res.data, item.name)
              }
            }).catch(err=>{
              console.log(err,'下载失败')
            })
        },
        //点击预览事件
        handlePreviewClick(index, type) {
            if(type==='pic') {
                this.$parent.handlePreview(index, this.piclist)
            } else {
                this.$parent.handlePreview(index, this.filelist)
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-panel {
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: #fff;
    .item {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name-progress {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .name {
                width: 94px;
                height: 100%;
            }
            /deep/ .el-progress-bar__outer {
                border-radius: 0;
                background-color: rgba(255,255,255,0.3);
            }
            /deep/ .el-progress-bar__inner {
                border-radius: 0;
            }
        }
        .rate {
            span {
                color: #c9c7c7;
            }
        }
        .rule {
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #fff;
            font-size: 15px;
            margin: 10px 0;
            :first-child {
                margin-top: 10px;
            }
            span {
                color: #357f96;
            }
        }
        .file-name {
            width: 92%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            img {
                width: 20px;
                height: 20px;
                margin-left: 16px;
            }
        }
    }
    .piclist {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 20px;
        .piclist-item {
            width: 90px;
            height: 60px;
            cursor: pointer;
            margin: 10px 8px 0 0;
            position: relative;
            video {
                width: 100%;
                height: 100%;
                cursor: pointer;
                object-fit: fill;//消除留白
            }
            .icon-play {
                position: absolute;
                width: 46px;
                height: 46px;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .piclist-item:nth-child(4n+0) {
            margin-right: 0;
        }
    }
}
</style>
